// extracted by mini-css-extract-plugin
export default {"formElement":"AddExpense_formElement__EI8tA","actionBtn":"AddExpense_actionBtn__JLsEZ","secondaryBtn":"AddExpense_secondaryBtn__LFT7z"};